import type { Directive } from 'vue'
import { storyblokEditable } from '@storyblok/js'
import { defineNuxtPlugin } from '#app'

const vEditableDirective: Directive<HTMLElement> = {
  beforeMount(el, binding) {
    if (binding.value) {
      const options = storyblokEditable(binding.value)
      el.setAttribute('data-blok-c', options['data-blok-c'])
      el.setAttribute('data-blok-uid', options['data-blok-uid'])
      el.classList.add('storyblok__outline')
    }
  },
}

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('editable', vEditableDirective)
})
